import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {persistReducer} from "redux-persist";
import storage from 'redux-persist/lib/storage';
import {loginApi, signOutApi} from "../api/authApi";

const initialState = {
    user: null,
    access_token: null,
    refresh_token: null,
    user_id: null,
    session_id: null,
    pre_authenticated: false,
    authenticated: false,
    pending_signin: false,
    pending_signout: false,
    pending_user: false,
};

export const signinAsync = createAsyncThunk(
    'auth/signin',
    async (amount) => {
        const response = await loginApi(amount);
        // The value we return becomes the `fulfilled` action payload
        return response.data;
    }
);

export const signoutAsync = createAsyncThunk(
    'auth/signout',
    async (amount) => {
       const response = await signOutApi(amount);
       // The value we return becomes the `fulfilled` action payload
       return response.data;
    }
);

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        signinUser: (state, action) => {
            state.access_token = action.payload.jwt;
            state.refresh_token = action.payload.refresh_token;
            state.user_id = action.payload.user_id;
           state.session_id = action.payload.session_id;
        },
        signoutUser: (state) => {
            state.user = null;
            state.access_token = null;
            state.refresh_token = null;
            state.user_id = null;
           state.session_id = null;
        },
        setUserAuth: (state, action) => {
            state.access_token = action.payload.jwt;
            state.refresh_token = action.payload.refresh_token;
        },
        setUserData: (state, action) => {
            state.user = action.payload;
        },
        setUserOrganisations: (state, action) => {
            state.user.organisations = action.payload;
        }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(signinAsync.pending, (state) => {
                state.pending_signin = true;
            })
            .addCase(signinAsync.fulfilled, (state, action) => {
                state.pending_signin = false;
                state.pre_authenticated = true;
            })
            .addCase(signoutAsync.pending, (state) => {
                state.pending_signout = true;
            })
            .addCase(signoutAsync.fulfilled, (state, action) => {
                state.authenticated = false;
                state.pre_authenticated = false;
                state.pending_signout = false;
                state.user = null;
            });
    },
});

const persistConfig = {
    key: 'auth',
    storage,
}

export const authPersistedReducer = persistReducer(persistConfig, authSlice.reducer);

export default authSlice.reducer;

export const {
    signinUser,
    signoutUser,
    setUserAuth,
    setUserData,
    setUserOrganisations,
} = authSlice.actions
